(function () {
  function initSelvaso(root) {
    if (!root || root.dataset.selvasoInit === '1') return;
    root.dataset.selvasoInit = '1';

    var optionName = root.getAttribute('data-option-name');
    var sectionId = root.getAttribute('data-section-id');
    var cards = root.querySelectorAll('.selvaso-card');

    var colDesktop = root.getAttribute('data-col-desktop') || '2';
    var grid = root.querySelector('.selvaso-grid');
    if (grid) {
      function applyCols() {
        if (window.matchMedia('(min-width: 749px)').matches) {
          grid.style.gridTemplateColumns = 'repeat(' + colDesktop + ', 1fr)';
        } else {
          grid.style.gridTemplateColumns = 'repeat(' + (root.getAttribute('data-col-movil') || '2') + ', 1fr)';
        }
      }
      applyCols();
      window.addEventListener('resize', applyCols);
    }

    var productVariants = document.querySelector('[data-main-product-variants]');
    if (!productVariants) {
      productVariants = document.querySelector('product-variants');
    }

    function nativeContainerForOption() {
      if (!productVariants) return null;
      var handle = optionName.toLowerCase().trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-]/g, '');
      var groups = productVariants.querySelectorAll('[data-js-product-variant]');
      for (var i = 0; i < groups.length; i++) {
        var dn = groups[i].getAttribute('data-name') || '';
        if (dn.indexOf('product-' + handle + '-') === 0) {
          return groups[i];
        }
      }
      var all = productVariants.querySelectorAll('[data-js-product-variant]');
      for (var j = 0; j < all.length; j++) {
        var txt = all[j].textContent.toLowerCase();
        if (txt.indexOf(optionName.toLowerCase()) !== -1) return all[j];
      }
      return null;
    }

    function hideNativeContainer() {
      var cont = nativeContainerForOption();
      if (cont) {
        cont.style.display = 'none';
        cont.setAttribute('data-selvaso-hidden', '1');
      }
    }

    function selectNativeValue(value) {
      var cont = nativeContainerForOption();
      if (!cont) return false;

      var radios = cont.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        var rv = r.value != null ? r.value : '';
        if (rv.trim() === value.trim()) {
          if (!r.checked) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
            r.dispatchEvent(new Event('input', { bubbles: true }));
            r.click && r.click();
          }
          return true;
        }
      }

      var select = cont.querySelector('select');
      if (select) {
        var opts = select.options;
        for (var k = 0; k < opts.length; k++) {
          if (opts[k].value.trim() === value.trim() || opts[k].textContent.trim() === value.trim()) {
            select.selectedIndex = k;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
        }
      }

      var labels = cont.querySelectorAll('label, [data-value]');
      for (var m = 0; m < labels.length; m++) {
        var lv = labels[m].getAttribute('data-value') || labels[m].textContent;
        if (lv && lv.trim() === value.trim()) {
          labels[m].click();
          return true;
        }
      }
      return false;
    }

    function setActive(value) {
      cards.forEach(function (c) {
        var active = c.getAttribute('data-selvaso-value').trim() === value.trim();
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
        var check = c.querySelector('.selvaso-card__check');
        if (active) {
          c.style.borderColor = c.getAttribute('data-active-color') || c.style.borderColor;
          if (check) check.style.display = 'flex';
        } else {
          c.style.borderColor = c.getAttribute('data-idle-color') || c.style.borderColor;
          if (check) check.style.display = 'none';
        }
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var value = card.getAttribute('data-selvaso-value');
        selectNativeValue(value);
        setActive(value);
      });
    });

    function syncFromNative() {
      var cont = nativeContainerForOption();
      if (!cont) return;
      var checked = cont.querySelector('input[type="radio"]:checked');
      if (checked) { setActive(checked.value); return; }
      var select = cont.querySelector('select');
      if (select && select.value) { setActive(select.value); }
    }

    hideNativeContainer();
    syncFromNative();

    if (productVariants) {
      productVariants.addEventListener('change', function () {
        setTimeout(syncFromNative, 30);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-selvaso]').forEach(initSelvaso);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
